import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EventCalendarDayModel } from '../../../model/events';
import { CalendarEventDay } from '../../core/CalendarEvent';
import { goToToday, showDetailEvent } from '../../../actions/events';

/**
 * Shows info about all the events in a day
 * @param {[EventCalendarDayModel]} events - Array of the events for this day. Obtained by Redux
 * @param {string} dateDay - Date of the day. Obtained by Redux
 * @param {function} hideDay - Function to destroy this component. Obtained by Redux
 */
class EventCalendarDay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startY: 0,
      currentY: 0,
      move: 0,
      fullDisplacement: false
    };

    this.handleOnTouchStart = this.handleOnTouchStart.bind(this);
    this.handleOnToucEnd = this.handleOnToucEnd.bind(this);
    this.handleOnTransitionEnd = this.handleOnTransitionEnd.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleSingleEventSelection = this.handleSingleEventSelection.bind(
      this
    );
  }

  componentDidMount() {
    // Calculate the max displacement
    // Calendar header:
    const calendarHeader = document.getElementById('calendar-header');
    // This component:
    const calendarEventDay = document.getElementById('calendar-event-day');
    this.setState({
      maxDisplacement:
        calendarHeader.getBoundingClientRect().top +
        calendarHeader.getBoundingClientRect().height -
        calendarEventDay.getBoundingClientRect().top,
      transition: false
    });
  }

  handleOnTransitionEnd() {
    this.setState({ transition: false });
  }

  handleOnTouchStart(e) {
    const { move } = this.state;
    this.setState({
      startY: e.touches[0].clientY - move,
      currentY: e.touches[0].clientY
    });
  }

  handleDrag(e) {
    e.stopPropagation();
    const move = e.touches[0].clientY - this.state.startY;
    // Get displacement speed. If it is high enough, this component will move to top or bottom
    const transition = Math.abs(e.touches[0].clientY - this.state.currentY) > 5;
    if (move > 0) {
      // Avoid going under the original position
      this.setState({ move: 0, currentY: e.touches[0].clientY, transition });
    } else if (move > this.state.maxDisplacement) {
      // Drag normaly
      this.setState({ move, currentY: e.touches[0].clientY, transition });
    } else {
      // Avoid going above the calendar header
      const { maxDisplacement } = this.state;
      this.setState({
        move: maxDisplacement,
        currentY: e.touches[0].clientY,
        transition
      });
    }
  }

  handleOnToucEnd() {
    // Depending on the speed (fullDisplacement) this component will move to top or bottom
    if (
      !this.state.fullDisplacement &&
      (this.state.move < this.state.maxDisplacement / 2 ||
        this.state.transition)
    ) {
      const { maxDisplacement } = this.state;
      this.setState({
        fullDisplacement: true,
        move: maxDisplacement,
        transition: true
      });
    } else if (
      this.state.fullDisplacement &&
      (this.state.move > this.state.maxDisplacement / 2 ||
        this.state.transition)
    ) {
      this.setState({
        fullDisplacement: false,
        move: 0,
        transition: true
      });
    }
  }

  // Action to run when a single event is clicked in the detailed view
  handleSingleEventSelection(id, dateDay) {
    const { showDetail, events } = this.props;
    const event = events.find(ev => ev.id === id).additionalInfo;
    showDetail(event, dateDay);
  }

  render() {
    const {
      dateDay,
      events,
      goToCurrentDay,
      selectedDate,
      showEventDetail
    } = this.props;
    return (
      <CalendarEventDay
        id="calendar-event-day"
        transform={this.state.move}
        transition={this.state.transition}
        dateDay={dateDay}
        dataEvent={events}
        handleEventSelection={(id, event) =>
          this.handleSingleEventSelection(id, event)
        }
        onClick={() => goToCurrentDay(selectedDate)}
        onTouchStart={this.handleOnTouchStart}
        onTouchMove={this.handleDrag}
        onTouchEnd={this.handleOnToucEnd}
        onTransitionEnd={this.handleOnTransitionEnd}
        showEventDetail={showEventDetail}
      />
    );
  }
}

EventCalendarDay.propTypes = {
  events: PropTypes.arrayOf(EventCalendarDayModel),
  dateDay: PropTypes.string,
  selectedDate: PropTypes.instanceOf(Date),
  goToCurrentDay: PropTypes.func,
  showEventDetail: PropTypes.bool
};

const mapStateToProps = ({ events }) => {
  const eventsFormatted = events.eventsByDay[events.dayDetail]
    ? events.eventsByDay[events.dayDetail].map(event => ({
        id: event.eventId,
        additionalInfo: events.events.find(ev => ev.eventId === event.eventId),
        eventName: event.title,
        status: event.status,
        eventHour: event.eventDayTimes
          ? event.eventDayTimes.map(hours => ({
              eventHourStart: `${hours.startTime.split(':')[0]}:${
                hours.startTime.split(':')[1]
              }`,
              eventHourEnd: `${hours.endTime.split(':')[0]}:${
                hours.endTime.split(':')[1]
              }`
            }))
          : []
      }))
    : null;
  return {
    dateDay: events.dayDetail,
    events: eventsFormatted,
    selectedDate: events.selectedDate
  };
};

const mapDispatchToProps = dispatch => ({
  goToCurrentDay: selectedDate => goToToday(dispatch, selectedDate),
  showDetail: (event, dateDay) => showDetailEvent(dispatch, event, dateDay)
});

export default connect(mapStateToProps, mapDispatchToProps)(EventCalendarDay);
